import { useRef, useState } from "react";
import cls from "classnames";
import { format } from "date-fns";
import {
  BlushFaceEmoji,
  NeutralFaceEmoji,
  SlightlyFrowningFaceEmoji,
  StarStruckEmoji,
} from "./RatingEmoji";
import useScrollHeight from "@qoohoo/common/hooks/useScrollHeight";
import UserAvatar from "@qoohoo/common/components/UserAvatar";

function ReviewCard({ review }) {
  const reviewRef = useRef(<p></p>);
  const [showMore, setShowMore] = useState(false);
  const isVisible = useScrollHeight(reviewRef);
  const ratedEmoji = getRatingEmoji(review.rating);
  const reviewBody = review?.review;
  const userNameOrFullname = review.user.fullname || review.user.username;

  function getRatingEmoji(rating) {
    switch (rating) {
      case 3:
        return <NeutralFaceEmoji />;
      case 4:
        return <BlushFaceEmoji />;
      case 5:
        return <StarStruckEmoji />;
      default:
        return <SlightlyFrowningFaceEmoji />;
    }
  }

  return (
    <li className="bg-[#22272B] rounded-lg px-6 py-5 min-w-[272px] md:min-w-[312px] max-w-[312px] md:max-w-none">
      <div className="flex items-center justify-between">
        <div className="flex space-x-3">
          <div className="flex justify-center items-center font-semibold object-cover min-w-[40px] w-10 h-10 overflow-hidden rounded-full bg-[#2b3135]">
            <UserAvatar
              avatarUrl={review.user.avatar?.url}
              userName={userNameOrFullname}
            />
          </div>
          <div className="flex flex-col space-y-0.5">
            <span className="text-sm font-medium capitalize font-inter truncate max-w-[120px] md:max-w-[272px] lg:max-w-[420px]">
              {review.user.fullname || "qoohoo user"}
            </span>
            <span className="text-xs text-[#A6A6A6] font-inter">
              {format(new Date(review.created_at), "MMM dd")}
            </span>
          </div>
        </div>
        <div className="text-lg rounded-full bg-[#2D3439] h-10 w-10 flex justify-center items-center p-2">
          {ratedEmoji}
        </div>
      </div>
      {reviewBody && (
        <>
          <p
            ref={reviewRef}
            className={cls(
              "text-sm sm:text-base mt-4 text-[#F0F0F0] max-w-[470px] leading-5 md:leading-6 whitespace-pre-wrap font-inter",
              `line-clamp-6 lg:line-clamp-4`,
              showMore && "!line-clamp-none"
            )}
          >
            {reviewBody}
          </p>
          {isVisible && (
            <button
              className="mt-2 font-semibold font-inter hover:opacity-90"
              onClick={() => {
                setShowMore(!showMore);
              }}
            >
              {showMore ? "show less" : "show more"}
            </button>
          )}
        </>
      )}
    </li>
  );
}

export default ReviewCard;
